var map = {
	"./BCG_Platinion_Online_Color_Light.png": "e9cb",
	"./deloitte.svg": "b49d",
	"./epidemicsound_logo.png": "b732",
	"./granges_logo.png": "7f7e",
	"./sca.svg": "f1af",
	"./sj_logo.png": "a006",
	"./sopra_steria.png": "257e",
	"./stora_enso_logo.png": "8aed",
	"./westforest.png": "7bde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ed7";